import { Link } from "react-router-dom";
import styles from "./Widgets.module.css";
import { useCurrentUser } from "../../useCurrentUser";
import { useCachedResource } from "../../lib/swrCache";
import { useFitCount } from "../../lib/useFitCount";
import { fraBizview } from "../../lib/prosjekter";

type ProsjektRad = {
  projectId: number;
  projectName: string;
  status?: string;
  projectManagerName?: string | null;
  currentPhaseName?: string | null;
};

const norm = (s: string) => s.toLowerCase().trim();

// Stabil farge per fase-navn (liten palett), så listen får litt liv.
// Kategorifargene (--kat-*) følger paletten.
const PALETT = ["blue", "amber", "teal", "violet", "grey", "yellow"].map((t) => `var(--kat-${t})`);
const faseFarge = (s: string) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETT[h % PALETT.length];
};

async function hentProsjekter(): Promise<ProsjektRad[]> {
  const r = await fetch("/api/projects");
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return fraBizview((await r.json()) as ProsjektRad[]);
}

export function MineProsjekter() {
  const user = useCurrentUser();
  const { data: prosjekter, feil } = useCachedResource("projects:all", hentProsjekter, {
    persist: true,
  });
  const [fitRef, n] = useFitCount(58);

  if (feil && !prosjekter) return <p className={styles.muted}>Kunne ikke laste prosjekter.</p>;
  if (!prosjekter) return <p className={styles.muted}>Laster…</p>;

  const mine = user
    ? prosjekter.filter(
        (p) => p.projectManagerName && norm(p.projectManagerName) === norm(user.displayName)
      )
    : [];

  if (!mine.length)
    return (
      <p className={styles.muted}>
        {user ? "Du står ikke som leder på noen prosjekter." : "Laster bruker…"}
      </p>
    );

  return (
    <div ref={fitRef} className={styles.fyll}>
      <div className={styles.liste}>
        {mine.slice(0, n).map((p) => {
          const fase = p.currentPhaseName ?? p.status ?? "";
          return (
            <Link key={p.projectId} to={`/projects/${p.projectId}`} className={styles.rad}>
              <span className={styles.radKol}>
                <span className={styles.radTittel}>{p.projectName}</span>
                <span className={styles.radMeta}>
                  {fase && (
                    <span
                      className={styles.prikk}
                      style={{ background: faseFarge(fase) }}
                      aria-hidden="true"
                    />
                  )}
                  {fase}
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
